var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"timestamp cat-ping-labels px-2 mr-2",attrs:{"label":"","small":""}},[_vm._v(" "+_vm._s(_vm.prefix)+_vm._s(_vm.formattedDate())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }